/* section-collection.js — extracted from sections/collection.liquid */
  function initCollectionPage() {
    let sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        let url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    let filterLayout   = document.querySelector('[data-filter-layout]');
    let layoutType     = filterLayout ? filterLayout.dataset.filterLayout : 'vertical';
    let filterToggle   = document.getElementById('collection-filter-toggle');
    let filtersPanel   = document.getElementById('collection-filters');
    let filterClose    = document.getElementById('collection-filter-close');

    if (filterToggle && filtersPanel) {
      function openFilters() {
        filtersPanel.hidden = false;
        requestAnimationFrame(function() {
          filtersPanel.dataset.open = '';
          filterToggle.setAttribute('aria-expanded', 'true');
        });
      }

      function closeFilters() {
        delete filtersPanel.dataset.open;
        filterToggle && filterToggle.setAttribute('aria-expanded', 'false');
        let dur = parseFloat(getComputedStyle(filtersPanel).transitionDuration) * 1000 || 0;
        setTimeout(function() {
          if (!filtersPanel.dataset.open) filtersPanel.hidden = true;
        }, dur);
      }

      if (layoutType === 'vertical' && window.innerWidth >= 900) {
        filtersPanel.hidden = false;
        filtersPanel.dataset.open = '';
      }

      let hasActiveFilters = filtersPanel.querySelector('.collection-filter-btn__count');
      if (hasActiveFilters) {
        filtersPanel.hidden = false;
        filtersPanel.dataset.open = '';
        filterToggle.setAttribute('aria-expanded', 'true');
      }

      filterToggle.addEventListener('click', function() {
        let expanded = this.getAttribute('aria-expanded') === 'true';
        expanded ? closeFilters() : openFilters();
      });

      filterClose && filterClose.addEventListener('click', closeFilters);

      /* Close drawer on outside click (drawer mode) */
      if (layoutType === 'drawer') {
        document.addEventListener('click', function(e) {
          if (filtersPanel.dataset.open !== undefined && !filtersPanel.contains(e.target) && e.target !== filterToggle && !filterToggle.contains(e.target)) {
            closeFilters();
          }
        });
      }
    }

    /* ── Filter form (AJAX) ── */
    let filterForm  = document.getElementById('collection-filter-form');
    let filterGrid  = document.getElementById('collection-grid');
    let filterCount = document.getElementById('collection-product-count');
    let filterTimer = null;

    function applyFilters(url) {
      document.body.setAttribute('data-filter-loading', '');
      fetch(url + (url.includes('?') ? '&' : '?') + 'sections=collection', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (!data.collection) return;
          let parser = new DOMParser();
          let doc = parser.parseFromString(data.collection, 'text/html');

          let newGrid = doc.getElementById('collection-grid');
          if (filterGrid && newGrid) filterGrid.innerHTML = newGrid.innerHTML;

          let newCount = doc.getElementById('collection-product-count');
          if (filterCount && newCount) filterCount.textContent = newCount.textContent;

          let newClear = doc.querySelector('.collection-filters__clear');
          let oldClear = document.querySelector('.collection-filters__clear');
          if (newClear && oldClear) oldClear.href = newClear.href;
          if (!newClear && oldClear) oldClear.hidden = true;

          window.history.pushState({ filterUrl: url }, '', url);
        })
        .catch(function() { window.location.href = url; })
        .finally(function() { document.body.removeAttribute('data-filter-loading'); });
    }

    if (filterForm) {
      filterForm.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
        cb.addEventListener('change', function() {
          clearTimeout(filterTimer);
          filterTimer = setTimeout(function() {
            let params = new URLSearchParams(new FormData(filterForm));
            applyFilters(window.location.pathname + '?' + params.toString());
          }, 80);
        });
      });

      filterForm.querySelectorAll('input[type="number"]').forEach(function(input) {
        input.addEventListener('change', function() {
          clearTimeout(filterTimer);
          filterTimer = setTimeout(function() {
            let params = new URLSearchParams(new FormData(filterForm));
            applyFilters(window.location.pathname + '?' + params.toString());
          }, 500);
        });
      });

      window.addEventListener('popstate', function(e) {
        let url = e.state && e.state.filterUrl ? e.state.filterUrl : window.location.href;
        applyFilters(url);
      });
    }

    /* ── Load More ── */
    function initLoadMore(btn) {
      if (!btn) return;
      btn.addEventListener('click', function() {
        let nextUrl = this.dataset.nextUrl;
        if (!nextUrl || this.dataset.loading) return;
        this.dataset.loading = 'true';
        let textEl    = this.querySelector('.collection-load-more__text');
        let spinnerEl = this.querySelector('.collection-load-more__spinner');
        if (textEl) textEl.hidden = true;
        if (spinnerEl) spinnerEl.hidden = false;
        this.disabled = true;

        fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function(r) { return r.text(); })
          .then(function(html) {
            let doc = new DOMParser().parseFromString(html, 'text/html');
            let newCards = doc.querySelectorAll('#collection-grid .card');
            let grid = document.getElementById('collection-grid');
            if (grid && newCards.length) {
              let frag = document.createDocumentFragment();
              newCards.forEach(function(c) { frag.appendChild(c); });
              grid.appendChild(frag);
            }
            let pag = document.getElementById('collection-pagination');
            let newPag = doc.getElementById('collection-pagination');
            if (pag && newPag) {
              pag.innerHTML = newPag.innerHTML;
              initLoadMore(document.getElementById('load-more-btn'));
            } else if (pag) {
              pag.remove();
            }
          })
          .catch(function() { window.location.href = nextUrl; });
      });
    }
    initLoadMore(document.getElementById('load-more-btn'));

    /* ── Infinite Scroll ── */
    let infiniteSentinel = document.querySelector('[data-infinite-scroll] ~ #collection-pagination .collection-infinite-sentinel');
    if (infiniteSentinel) {
      let infiniteLoading = false;
      let infiniteSpinner = document.querySelector('.collection-infinite-spinner');

      let io = new IntersectionObserver(function(entries) {
        if (!entries[0].isIntersecting || infiniteLoading) return;
        let nextUrl = infiniteSentinel.dataset.nextUrl;
        if (!nextUrl) return;

        infiniteLoading = true;
        if (infiniteSpinner) infiniteSpinner.hidden = false;

        fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function(r) { return r.text(); })
          .then(function(html) {
            let doc = new DOMParser().parseFromString(html, 'text/html');
            let newCards = doc.querySelectorAll('#collection-grid .card');
            let grid = document.getElementById('collection-grid');
            if (grid && newCards.length) {
              let frag = document.createDocumentFragment();
              newCards.forEach(function(c) { frag.appendChild(c); });
              grid.appendChild(frag);
            }
            let newSentinel = doc.querySelector('.collection-infinite-sentinel');
            if (newSentinel) {
              infiniteSentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
            } else {
              io.disconnect();
              infiniteSentinel.remove();
            }
          })
          .catch(function() { io.disconnect(); })
          .finally(function() {
            infiniteLoading = false;
            if (infiniteSpinner) infiniteSpinner.hidden = true;
          });
      }, { rootMargin: '200px' });

      io.observe(infiniteSentinel);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionPage);
  } else {
    initCollectionPage();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector('[data-filter-layout]')) {
      initCollectionPage();
    }
  });
